import { render, staticRenderFns } from "./PaymentProviderRadioList.vue?vue&type=template&id=0a2a0697&scoped=true"
import script from "./PaymentProviderRadioList.vue?vue&type=script&lang=js"
export * from "./PaymentProviderRadioList.vue?vue&type=script&lang=js"
import style0 from "./PaymentProviderRadioList.vue?vue&type=style&index=0&id=0a2a0697&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2a0697",
  null
  
)

export default component.exports